import { render, staticRenderFns } from "./bindWeChatUser.vue?vue&type=template&id=633550dc&scoped=true"
import script from "./bindWeChatUser.vue?vue&type=script&lang=js"
export * from "./bindWeChatUser.vue?vue&type=script&lang=js"
import style0 from "./bindWeChatUser.vue?vue&type=style&index=0&id=633550dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633550dc",
  null
  
)

export default component.exports